














































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import {
  InvoiceCollectionModelDefault,
  InvoiceCollectionWithModelDefault
} from '@/modules/invoice/models/invoice-collection.model'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import { PanelInvoiceRoute } from '@/modules/invoice/routes/panel-invoice.route'
import { InvoiceStatus } from '@/modules/invoice/models/invoice-reource.model'
import ActionShowButtonI from '@/modules/shared/components/shared/table/action/ActionShowButtonI.vue'
import PanelInvoiceInfoDialog from '@/modules/invoice/components/panel/PanelInvoiceInfoDialog.vue'

@Component({
  components: {
    ActionShowButtonI,
    BaseButton,
    ActionShowButton
  }
})
export default class PanelInvoiceActions extends Vue {
  constructor(
    private readonly routes: PanelInvoiceRoute
  ) {
    super()
  }

  private invoiceStatus = InvoiceStatus

  @Prop() invoice!: InvoiceCollectionModelDefault
  @Prop() withData!: InvoiceCollectionWithModelDefault

  openDialog() {
    this.$q.dialog({
      component: PanelInvoiceInfoDialog,
      invoice: this.invoice,
      withData: this.withData
    })
  }

  showPaymentButton(invoice) {
    return invoice.status === InvoiceStatus.UNPAID
      || invoice.status === InvoiceStatus.PENDING
  }

}

